const _excluded = ["markers", "showControls", "zoom", "layers"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;} /* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet.markercluster';

import uniqueID from "../../shared/uniqueID";
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import {

  getClusterMarker,

  parseMarkerPoint,

  checkMapInitialization } from "./MapHelper";

import { getMapProvider } from "./TilesProviderFactory";



















const LMap = (_ref) =>





{let { markers: pointMarkers = [], showControls = true, zoom = 6, layers } = _ref,props = _objectWithoutProperties(_ref, _excluded);
  let map;
  let markerGroup;
  const [currentMarkers, setCurrentMarkers] = useState();
  const [currentTilesProvider, setCurrentTilesProvider] = useState(props.tilesProvider);
  const containerId = uniqueID();

  const clickHandler = (markerPoint) => {
    if (!map.dragging.enabled()) {
      map.dragging.enable();
      return;
    }
    if (!props.onClick) {
      return;
    }
    markerGroup.clearLayers();
    getClusterMarker(_objectSpread(_objectSpread({}, markerPoint), {}, { properties: {} })).addTo(markerGroup);
    const event = { lngLat: [markerPoint.latlng.lng, markerPoint.latlng.lat] };
    props.onClick(event);
  };

  const initMarkers = () => {
    const markers = pointMarkers.map((pointMarker) =>
    parseMarkerPoint(pointMarker, props.templatesInfo, props.renderPopupInfo)
    );

    markers.forEach((m) => getClusterMarker(m).addTo(markerGroup));
    markerGroup.on('clusterclick', (cluster) => {var _props$clickOnCluster;
      (_props$clickOnCluster = props.clickOnCluster) === null || _props$clickOnCluster === void 0 ? void 0 : _props$clickOnCluster.call(props, cluster.layer.getAllChildMarkers());
    });
    markerGroup.on('click', (marker) => {var _props$clickOnMarker;
      (_props$clickOnMarker = props.clickOnMarker) === null || _props$clickOnMarker === void 0 ? void 0 : _props$clickOnMarker.call(props, marker.layer);
    });
    if (pointMarkers.length) {
      map.fitBounds(markerGroup.getBounds(), { maxZoom: zoom });
    }
    markerGroup.addTo(map);
  };

  const shouldScroll = props.renderPopupInfo || props.onClick !== undefined;
  const enableMapGestures = () => {
    if (!map.scrollWheelZoom.enabled()) {
      if (shouldScroll) {
        map.scrollWheelZoom.enable();
      }
    }
  };

  const disableMapGestures = (event) => {
    if (event.target && !map.getContainer().contains(event.target)) {
      map.scrollWheelZoom.disable();
      map.dragging.disable();
    }
  };

  const initMap = () => {
    const baseMaps = getMapProvider(props.tilesProvider, props.mapApiKey);
    const mapLayers = {};
    Object.keys(baseMaps).forEach((key) => {
      const mapKey = baseMaps[key].key;
      if (layers && layers.length && !layers.includes(mapKey)) {
        return;
      }
      mapLayers[key] = baseMaps[key].layer;
    });

    map = L.map(containerId, {
      center: [props.startingPoint[0].lat, props.startingPoint[0].lon],
      zoom,
      maxZoom: 20,
      minZoom: 2,
      zoomControl: false,
      preferCanvas: true,
      scrollWheelZoom: false,
      wheelDebounceTime: 100,
      dragging: false
    });

    map.on('click', enableMapGestures);
    document.addEventListener('click', disableMapGestures);
    map.getPanes().mapPane.style.zIndex = '0';
    markerGroup = L.markerClusterGroup();

    if (showControls) {
      L.control.zoom({ position: 'bottomright' }).addTo(map);
    }
    if (showControls && Object.values(mapLayers).length > 1) {
      L.control.layers(mapLayers, {}, { position: 'bottomright', autoZIndex: false }).addTo(map);
    }

    const initialLayer = Object.values(mapLayers)[0];
    initialLayer.options.zIndex = 0;
    initialLayer.addTo(map);
    initMarkers();
    map.on('click', clickHandler);
  };

  useEffect(() => {
    const reRender = currentTilesProvider !== props.tilesProvider || !props.onClick;

    if (reRender || currentMarkers === undefined) {
      setCurrentMarkers(pointMarkers);
      setCurrentTilesProvider(props.tilesProvider);
      checkMapInitialization(map, containerId);
      initMap();
    }
    return () => {
      if (map && reRender) {
        map.off('click', enableMapGestures);
        document.removeEventListener('click', disableMapGestures);
        map.remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pointMarkers, props.tilesProvider, props.mapApiKey]);

  return (/*#__PURE__*/
    _jsx("div", { className: "map-container", "data-testid": "map-container" }, void 0, /*#__PURE__*/
    _jsx("div", {
      id: containerId,
      className: "leafletmap",
      style: { width: '100%', height: props.height } }
    )
    ));

};

export { LMap };